import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { Icon } from '@haldor/ui';
import './Collapsible.scss';

var Collapsible = /*#__PURE__*/function (_Component) {
  _inherits(Collapsible, _Component);

  var _super = _createSuper(Collapsible);

  function Collapsible(props) {
    var _this;

    _classCallCheck(this, Collapsible);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_setContent", function (element) {
      return _this.content = element;
    });

    _defineProperty(_assertThisInitialized(_this), "_setContainer", function (element) {
      return _this.container = element;
    });

    _defineProperty(_assertThisInitialized(_this), "UNSAFE_componentWillReceiveProps", function (nextProps) {
      if (nextProps.open != null) {
        if (nextProps.open != _this.state.open) {
          _this.toggle();
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      if (_this.props.open == true || _this.props.defaultOpen == true) {
        _this.container.style.height = 'auto';
        _this.container.style.overflow = 'visible';
      }
    });

    _defineProperty(_assertThisInitialized(_this), "toggle", function (event) {
      if (event != null) {
        event.preventDefault();
      }

      _this.setState({
        open: !_this.state.open
      }, function () {
        if (_this.state.open) {
          _this.container.style.height = _this.content.clientHeight + 'px'; // Animation timing: Fire after CSS transition is completed

          setTimeout(function () {
            _this.container.style.height = 'auto';
            _this.container.style.overflow = 'visible';
          }, _this.animationLength);
        } else {
          _this.container.style.height = _this.content.clientHeight + 'px';
          _this.container.style.overflow = 'hidden'; // Set height 0 to animate collapsing

          setTimeout(function () {
            _this.container.style.height = '0px';
          }, 35);
        }

        if (_this.props.onChange != null) {
          _this.props.onChange(_this.state.open);
        }
      });
    });

    var open = false;

    if (props.open != null) {
      open = props.open;
    } else {
      if (props.defaultOpen != null) {
        open = props.defaultOpen;
      }
    }

    var className = null;

    if (props.className != null) {
      className = props.className;
    }

    _this.state = {
      open: open,
      className: className
    };
    _this.content = null;
    _this.container = null;
    _this.animationLength = 270;
    return _this;
  }

  _createClass(Collapsible, [{
    key: "render",
    value:
    /* Render methods */
    function render() {
      var _this$props$className;

      var open = this.state.open;
      return /*#__PURE__*/React.createElement("div", {
        className: open ? 'collapsible open' : 'collapsible'
      }, this.props.trigger != null ? /*#__PURE__*/React.createElement("div", {
        className: "collapsible-trigger",
        onClick: this.toggle
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          alignItems: 'center'
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          flex: 0
        },
        className: (_this$props$className = this.props.className) !== null && _this$props$className !== void 0 ? _this$props$className : null
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Chevron"
      })), /*#__PURE__*/React.createElement("div", {
        style: {
          flex: 1
        }
      }, typeof this.props.trigger === 'function' ? this.props.trigger(open) : this.props.trigger, this.props.badge != null ? /*#__PURE__*/React.createElement("span", {
        className: "badge"
      }, this.props.badge) : null))) : null, /*#__PURE__*/React.createElement("div", {
        ref: this._setContainer,
        className: "collapsible-content"
      }, /*#__PURE__*/React.createElement("div", {
        ref: this._setContent
      }, this.props.children)));
    }
  }]);

  return Collapsible;
}(Component);

export default Collapsible;